import clsx from "clsx";
import React from "react";
import { ColorPill, ColorPills } from "web/react/components/color-pills/color-pills";
// eslint-disable-next-line css-modules/no-unused-class
import styles from "web/react/components/color-pills/color-pills.module.css";
import { StandardFilterProps } from "web/types/feed-filters";
import { ColorsFilterSection, InputFilterOption } from "web/types/universal-filters";

export function FeedFilterColors(props: FeedFilterColorsProps): JSX.Element {
    const pills = (props.item.option_groups[0].options as InputFilterOption[]).map(
        (color): ColorPill => ({
            id: color.id,
            url: color.url,
            color: color.value as string,
            label: color.label,
            checked: props.pendingFilterInfo.getChecked(color),
            className: styles.colorPill,
            onClick: () => props.onClick(color),
        })
    );

    return (
        <ColorPills
            pills={pills}
            className={clsx(styles.wrapper, styles.wrapperFeedFilterColors)}
        />
    );
}

interface FeedFilterColorsProps extends StandardFilterProps {
    item: ColorsFilterSection;
}
